import React from 'react';
import {Switch, Route} from 'react-router-dom';
import Meta from '../../../../model/Meta';

/* Steps */
import DefaultView from './DefaultView';
import RealEstateMortgageStep1 from './RealEstateMortgageStep1';
import RealEstateMortgageStep2 from './RealEstateMortgageStep2';
import RealEstateMortgageStep3 from './RealEstateMortgageStep3';
import RealEstateMortgageStep4 from './RealEstateMortgageStep4';
import RealEstateMortgageStep5 from './RealEstateMortgageStep5';
import RealEstateMortgageStep6 from './RealEstateMortgageStep6';
import Ty from './Ty';

const RealEstateMortgage = (props)=>{
    let basePath = "/contracts/real-estate/real-estate-mortgage";
    
    const meta = {
        title: "Real Estate Mortgage Contract",
        description: "A real estate mortgage (REM) is a document in which the owner uses the title to a real property as security for a loan described in a promissory note. The REM must be signed by the owner (borrower/mortgagor), acknowledged before a notary public, and recorded with the Registry of Deeds. Should the owner fail to make the payments described in the promissory note, the lender (mortgagee) may have the real property foreclosed whether judicially or extrajudicially."
    }

	return (
		<div className="page page-inner page-contract">
            <Meta {...meta}/>
            <div className="container-fluid">
                <div className="p-0">
                    <div className="page-content py-3">

                        <Switch>
                            <Route path={basePath+"/1"} component={RealEstateMortgageStep1} />
                            <Route path={basePath+"/2"} component={RealEstateMortgageStep2} />
                            <Route path={basePath+"/3"} component={RealEstateMortgageStep3} />
                            <Route path={basePath+"/4"} component={RealEstateMortgageStep4} />
                            <Route path={basePath+"/5"} component={RealEstateMortgageStep5} />
                            <Route path={basePath+"/6"} component={RealEstateMortgageStep6} />
                            <Route path={basePath+"/ty"} component={Ty} />                            
                            <Route component={DefaultView} />
                        </Switch>

                    </div>
                </div>
            </div>
        </div>
	);
}

export default RealEstateMortgage;


// WEBPACK FOOTER //
// ./src/pages/contracts/real-estate/real-estate-mortgage/RealEstateMortgage.js